import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Homepage from './components/homepage/Homepage';
import EmiPage from './components/emiPage/EmiPage';
import PrivacyPolicyPage from './components/privacyPolicy/PrivacyPolicyPage';
import LenderPage from './components/lender/LenderPage';
import LendingPartnerPage from './components/lendingPartnerPage/LendingPartnerPage';
import EligibilityPage from './components/eligibilityPage/EligibilityPage';
import ApplicationJourneyPage from './components/applicationJourney/ApplicationJourneyPage';
import ThankYouPage from './components/applicationJourney/ThankYouPage';

// Component to handle navigation restoration
const NavigationRestorer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Clear any old stored page info when app loads
    // We want users to naturally land on homepage when returning from lender pages
    const storedPageInfo = localStorage.getItem('snapfunds_previous_page');
    if (storedPageInfo) {
      try {
        const pageInfo = JSON.parse(storedPageInfo);
        const timeDiff = Date.now() - pageInfo.timestamp;
        
        // Clear stored info if it's old (more than 1 hour)
        if (timeDiff >= 3600000) {
          localStorage.removeItem('snapfunds_previous_page');
        }
      } catch (error) {
        console.error('Error parsing stored page info:', error);
        localStorage.removeItem('snapfunds_previous_page');
      }
    }
  }, [navigate, location.pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <NavigationRestorer />
      <Header />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/emi-calculator" element={<EmiPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
        <Route path="/lending-partner/:lenderName" element={<LenderPage />} />
        <Route path="/lending-partner" element={<LendingPartnerPage />} />
        <Route path="/application/check-eligibility" element={<EligibilityPage />} />
        <Route path="/application/thank-you" element={<ThankYouPage />} />
        <Route path="/application/journey" element={<ApplicationJourneyPage />} />
        <Route path="/application/journey#personaldetails" element={<ApplicationJourneyPage />} />
        <Route path="/application/journey#professionaldetails" element={<ApplicationJourneyPage />} />
        <Route path="/application/journey#documents" element={<ApplicationJourneyPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;